import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel'];

  connect() {
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    document.addEventListener('click', this.handleTriggerClick);
  }

  disconnect() {
    document.removeEventListener('click', this.handleTriggerClick);
  }

  handleTriggerClick(event) {
    const trigger = event.target.closest(`[data-version-history-trigger="${this.element.id}"]`);
    if (!trigger) return;

    event.preventDefault();
    this.open();
  }

  open() {
    this.panelTarget.classList.remove('hidden');
  }

  close() {
    this.panelTarget.classList.add('hidden');
  }
}
